<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" slot="left">
      <mt-button slot="left" class="nav-btn"
        ><span style="font-size: 0.34rem">任务详情</span></mt-button
      >
    </mt-header>
    <div class="zj-mt-content">
      <div class="zj-mt-map">
        <ZJMobileApp></ZJMobileApp>
      </div>
      <div class="zj-mt-taskinfo">
        <mt-cell title="任务详情：" :label="Task.TaskTiltle">
          <img class="iconLeft" slot="icon" src="../images/icon1.png" />
        </mt-cell>
        <mt-cell title="任务描述：" :label="Task.TaskDesc">
          <img class="iconLeft" slot="icon" src="../images/icon2.png" />
        </mt-cell>
        <mt-cell title="任务地址：" :label="Task.Location">
          <img class="iconLeft" slot="icon" src="../images/icon3.png" />
        </mt-cell>
        <mt-cell title="负责人：" :label="ChargerPerson">
          <img class="iconLeft" slot="icon" src="../images/icon4.png" />
        </mt-cell>
        <mt-cell title="计划响应时间：" :label="PlanResponseTimeStr">
          <img class="iconLeft" slot="icon" src="../images/icon5.png" />
        </mt-cell>
      </div>
      <!-- <div class="zj-mt-rescueteam">涉及救援队人员</div> -->
    </div>
    <div class="zj-mt-footer" v-if="!Finshed">
      <mt-button
        type="primary"
        class="btnsubmit"
        @click.native="IsVisible = true"
        size="large"
        style="font-size: 30px"
        ><span style="font-size: 0.34rem">{{ finishDesc }}</span>
      </mt-button>
    </div>
    <mt-popup v-model="IsVisible" position="bottom" class="mint-popup">
      <mt-header title="任务反馈"></mt-header>
      <!-- <div class="filed-label">执行状态</div>
      <div class="filed-label">
        <mt-button
          size="small"
          :class="{ active: Finshed }"
          @click.native="OnExecStatusChanged('2')"
          >已完成</mt-button
        >
        <mt-button
          size="small"
          :class="{ active: Unfinished }"
          @click.native="OnExecStatusChanged('1')"
          >未完成</mt-button
        >
      </div> -->
      <div class="filed-label"><span style="color: red">*</span>反馈内容</div>
      <mt-field
        label
        placeholder="填写任务执行情况的说明"
        type="textarea"
        rows="4"
        v-model="Task.FeedbackDesc"
      ></mt-field>

      <div class="filed-label">图片</div>
      <nutimagepicker
        :imgList.sync="imgList"
        delMode="longtap"
        longTapTime="1000"
      ></nutimagepicker>

      <div class="filed-label">短视频</div>
      <nutvideopicker
        :imgList.sync="videoList"
        accept="video/*"
        delMode="longtap"
        longTapTime="1000"
      ></nutvideopicker>
      <!-- <div
        class="media-wrapper"
        v-for="item in FeedAttachList"
        :key="item.AttachId"
      >
        <video v-if="isVideo(item.FileType)" controls>
          <source v-bind:src="item.FileUrl" type="video/mp4" />
          <source v-bind:src="item.FileUrl" type="video/ogg" />
          Your browser does not support the video tag.
        </video>
        <img
          v-else-if="isImage(item.FileType)"
          v-bind:src="item.FileUrl"
          alt="图片链接无效"
        />
        <div v-else>不支持的文件类型 {{ item.FileType }}</div>
      </div> -->
      <mt-button
        class="popup-submit"
        type="primary"
        size="large"
        @click.native="submitFeedback"
        ><span style="font-size: 0.34rem">提交</span></mt-button
      >
    </mt-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Cell, Toast, Indicator } from "mint-ui";
import MyApis from "../../../../../plugins/emergency/src/apis";
import ZJApp from "../../../app";
import nutimagepicker from "../../../components/imagepicker/imagepicker.vue";
import "../../../components/imagepicker/imagepicker.scss";
import nutvideopicker from "../../../components/imagepicker/videopicker.vue";
import "../../../components/imagepicker/videopicker.scss";

import ZJMobileApp from "./component/map.vue";

Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);

export default {
  name: "EmgTaskCenter",
  controller: "UI",
  action: "TaskCenter",
  components: {
    ZJMobileApp,
    nutimagepicker,
    nutvideopicker,
  },
  props: {
    query: {
      //任务执行id
      ExecutTaskId: {
        type: String,
        require: true,
        default: "",
      },
    },
  },
  data: function () {
    return {
      Finshed: false,
      Unfinished: false,
      imgList: [],
      videoList: [],
      Task: {
        ExecutId: "",
        TaskTiltle: "",
        TaskDesc: "",
        Location: "",
        PlanResponseTime: "",
        ChargerName: "",
        Phone: "",
        Longitude: "",
        Latitude: "",
        ExecStatus: "",
        FeedbackDesc: "",
      },
      IsVisible: false,
      // AddressBookObj: null,
      // EventObj: null,
      // FeedBackMsg: "",
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack",
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTasknewtaskfortaskcenter",
      },
      finishDesc: "已完成，去反馈",
      FeedAttachList: [],
      FeedAttachImgList: [],
    };
  },
  created() {
    // this.executTaskId = this.$route.query.ExecutTaskId;
    // this.book_id = this.$route.query.BookId;
    // this.event_id = this.$route.query.EventId;
    this.Init();
    this.GetFeedBack();
  },
  methods: {
    Init() {
      Indicator.open("加载中...");
      return ZJApp.ZJUtils.waitAll([() => this.GetTask()]).then(() => {
        Indicator.close();
      });
    },
    GetTask() {
      let ExecutTaskSearch = {
        ExecutTaskId: this.query.ExecutTaskId,
        Validity: 1,
      };
      let that = this;
      return new MyApis.ExecutTaskApi()
        .GetItemById(ExecutTaskSearch)
        .then((res) => {
          if (res.RspCode == "1" && res.data.Data != null) {
            var result = res.data.Data;
            if (result.TaskStatus == "2") {
              that.Finshed = true;
              that.$set(this, "finishDesc", "反馈详情");
              that.finishDesc = "反馈详情";
            } else {
              that.Finshed = false;
              that.finishDesc = "已完成，去反馈";
            }
            // eslint-disable-next-line no-undef
            that.Task = $.extend({}, that.Task, result);
          }
        })
        .catch((e) => {
          //Toast(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          console.log(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetFeedBack() {
      let that = this;
      let ExecutTaskSearch = {
        ExecutTaskId: this.query.ExecutTaskId,
        Validity: 1,
      };
      console.log(that.ExecutId);
      that.FeedAttachImgList = [];
      new MyApis.ExecutFeedbackApi()
        .FindByConditions(ExecutTaskSearch)
        .then((r) => {
          r = r.data.Data;
          if (r && r.length > 0) {
            that.FeedAttachList = r[0].FeedAttachList;
          }
          if (r && r.length > 0) {
            r[0].FeedAttachList.forEach((item) => {
              if (that.isImage(item.FileType)) {
                item.src = item.FileUrl;
                item.id = item.id;
                that.FeedAttachImgList.push(item);
              }
            });
          }
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "加载反馈列表异常！",
            type: "error",
          });
        });
    },
    OnExecStatusChanged(val) {
      this.Task.ExecStatus = val;
      this.Task.TaskStatus = val;
      this.Finshed = val == 2;
      this.Unfinished = val == 1;
    },
    submitFeedback() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();
      //默认反馈就是完成任务
      this.Task.ExecStatus = 2;
      this.Task.TaskStatus = 2;
      // if (!that.Task.ExecStatus) {
      //   Toast({ message: "请反馈执行状态" });
      //   return false;
      // }

      // Indicator.open({
      //   text: "反馈上传中...",
      //   spinnerType: "triple-bounce",
      // });
      //插入反馈数据
      new MyApis.ExecutFeedbackApi()
        .AddItem(that.newfeedback(uuid))
        .then((r) => {
          let data = r.data.Data;
          if (data) {
            that
              .uploadAttch(uuid)
              .then((r) => {
                console.log("上传", r);
                if (r && r.length > 0) {
                  that
                    .submitFeedBackAttachment(uuid, r)
                    // eslint-disable-next-line no-unused-vars
                    .then((r) => {
                      //增加反馈成功，发送反馈成功消息
                      that.$notify.broadcase({
                        key:
                          that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
                        data: that.feedback,
                      });

                      Indicator.close();
                      // Toast({ message: "事态反馈成功" });
                    })
                    .catch((e) => {
                      console.error(e);
                      Indicator.close();
                      // Toast({
                      //   message: e.RspMsg
                      //     ? e.RspMsg
                      //     : "事态反馈成功，上传附件失败！",
                      // });
                    });
                } else {
                  //增加反馈成功，发送反馈成功消息
                  that.$notify.broadcase({
                    key: that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
                    data: that.feedback,
                  });

                  Indicator.close();
                  //  Toast({ message: "事态反馈成功" });
                }
              })
              // eslint-disable-next-line no-unused-vars
              .catch((e) => {
                console.log(e);
                Indicator.close();
                // Toast({ message: "事态反馈成功，上传附件失败！" });
              });

            //更新任务状态
            new MyApis.ExecutTaskApi()
              .UpdateItem(that.Task)
              .then((r) => {
                let data = r.data.Data;
                if (data) {
                  //发送任务完成消息
                  console.log(
                    "broadcase : " +
                      that.msgkey.emergencyFinishTaskKey +
                      that.Task.ExecutId
                  );
                  that.$notify.broadcase({
                    key:
                      that.msgkey.emergencyFinishTaskKey + that.Task.ExecutId,
                    data: that.Task,
                  });

                  this.IsVisible = false;
                  this.finishDesc = "反馈详情";
                  this.Finshed = true;
                  Toast({ message: "任务反馈成功" });
                } else {
                  Toast({ message: "更新任务状态失败" });
                }
              })
              .catch((e) => {
                console.error(e);
                Toast({ message: e.RspMsg ? e.RspMsg : "更新任务状态失败" });
              });
          } else {
            Toast({ message: r.RspMsg ? r.RspMsg : "任务反馈失败！" });
          }
        })
        .catch((e) => {
          console.error(e);
          Toast({ message: e.RspMsg ? e.RspMsg : "任务反馈失败！" });
        });
    },
    newfeedback: function (uuid) {
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;
      var feedback = {
        Creater: user,
        Modifier: user,
        CreateTime: new Date(),
        ModifyTime: new Date(),
        Validity: 1,
        OrgId: deptId,
        FeedbackId: uuid,
        ExecutId: this.Task.ExecutId,
        ExecutTaskId: this.Task.ExecutTaskId,
        TaskTiltle: this.Task.TaskTiltle,
        TaskDesc: this.Task.TaskDesc,
        FeedType: "1", //反馈类型(1-事件反馈2-事态上报)
        Charger: this.Task.ChargerName,
        TelPhone: this.Task.Phone,
        PlanResponseTime: this.Task.PlanResponseTime,
        ExecStatus: this.Task.ExecStatus,
        FeedbackDesc: this.Task.FeedbackDesc,
      };
      return feedback;
    },
    //插入附件
    uploadAttch(feedid) {
      const that = this;
      return new Promise((resolve, reject) => {
        let mediaList = [].concat(that.imgList, that.videoList);
        var arr = [];
        console.log("mediaList", mediaList);
        mediaList.forEach((item) => {
          var option = {
            file: item.file,
            data: {
              module: "taskCenter", //模块名
              submodule: "H5", //子模块
              assocID: feedid, //业务ID
              uploader: "H5", //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        ZJApp.ZJUtils.waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    //插入反馈附件
    submitFeedBackAttachment(feedid, rArr) {
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;

      var arr = [];
      rArr.forEach((r) => {
        arr.push(
          new MyApis.FeedAttachApi().AddItem({
            Creater: user,
            Modifier: user,
            CreateTime: new Date(),
            ModifyTime: new Date(),
            Validity: 1,
            OrgId: deptId,
            AttachId: ZJApp.ZJUtils.uuid(),
            FeedBackId: feedid,
            FileName: r.FileName,
            FileActName: r.FileName,
            FileUrl: r.DownloadPath,
            FileType: r.Extension,
            UploadDate: new Date(),
            FileId: r.FileID,
            PhysicalPath: r.Path,
          })
        );
      });

      return new Promise((resolve, reject) => {
        ZJApp.ZJUtils.waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    isImage: function (filename) {
      return ZJApp.ZJUtils.isImage(filename);
    },
    isVideo: function (filename) {
      return ZJApp.ZJUtils.isVideo(filename);
    },
  },
  computed: {
    ChargerPerson: function () {
      return this.Task.ChargerName + " " + this.Task.Phone;
    },
    PlanResponseTimeStr: function () {
      return this.Task.PlanResponseTime + "分钟";
    },
    feedback: function () {
      let uuid = ZJApp.ZJUtils.uuid();
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;
      var feedback = {
        Creater: user,
        Modifier: user,
        CreateTime: new Date(),
        ModifyTime: new Date(),
        Validity: 1,
        OrgId: deptId,
        FeedbackId: uuid,
        ExecutId: this.Task.ExecutId,
        ExecutTaskId: this.Task.ExecutTaskId,
        TaskTiltle: this.Task.TaskTiltle,
        TaskDesc: this.Task.TaskDesc,
        FeedType: "1", //反馈类型(1-事件反馈2-事态上报)
        Charger: this.Task.ChargerName,
        TelPhone: this.Task.Phone,
        PlanResponseTime: this.Task.PlanResponseTime,
        ExecStatus: this.Task.ExecStatus,
        FeedbackDesc: this.Task.FeedbackDesc,
      };
      return feedback;
    },
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
};
</script>
<style lang="scss" scoped>
.iconLeft {
  width: 0.54rem;
  height: 0.72rem;
}
.btnsubmit {
  font-size: 0.28rem;
}
</style>